import React from "react";
import { Form, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";

const UserDetailPassword = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="password"
      label="Confirm Password"
      rules={[
        {
          required: true,
          message: "Please input password to change your email",
        },
        {
          min: 6,
          message: "Min length must be at least 6 characters",
        },
        {
          whitespace: true,
          message: "Invalid Password",
        },
      ]}
    >
      <Input.Password
        showCount
        maxLength={16}
        minLength={6}
        prefix={<LockOutlined className="form-item-icon" />}
        placeholder="Verify Your Password"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default UserDetailPassword;
